import InnerComponent from '@Components/Vendors/VendorsHome';
import orgContainer from '@Components/AppContainer';

const OrgSellers = () => ((orgContainer(InnerComponent)));
export default OrgSellers;
